<template>
  <div
    id="ranges"
    class="row"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <form-toolbar
              :title="title"
              :loading="form.busy"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              :id="ref"
              class="wrap justify-space-around form-body"
            >
              <v-col
                cols="12"
                md="12"
              >
                <v-select
                  v-model="form.type_document"
                  :items="documentTypes"
                  label="Tipo de Documento"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.serie"
                  label="Serie"
                  placeholder="Serie"
                  maxlength="10"
                  :rules="[]"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.prefix"
                  :rules="[rules.required, rules.numeric]"
                  label="Prefijo"
                  placeholder="Prefijo"
                  required
                  maxlength="2"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.min_value"
                  :rules="[rules.required, rules.numerationMinValue]"
                  type="number"
                  label="Desde"
                  placeholder="Desde"
                  required
                  maxlength="20"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.max_value"
                  :rules="[rules.required,rules.numerationMaxValue]"
                  type="number"
                  label="Hasta"
                  placeholder="Hasta"
                  @change="numerationToValue"
                  required
                  maxlength="20"
                />
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Form from 'vform';
import FormToolbar from '~/components/Form/Toolbar';

export default {
    components: {
      FormToolbar,
    },
    props: {
      enterpriseId: { default: '' },
      dealerId: { default: '' },
      serieId: { default: '' },
    },
    data: () => ({
      form: new Form({
        id: '',
        type_document: null,
        serie: null,
        prefix: '00',
        min_value: null,
        max_value: '',
        correlative: 0,
        busy: false,
        active: 0,
      }),
      valid: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
        numerationMinValue: (v) => (v > 0) || 'El campo debe ser mayor a 0',
        numerationMaxValue: (v) => (v <= 99999999) || 'El número máximo permitido es 99999999',
        numeric: (v) => /^[0-9]*$/.test(v) || 'El campo solo permite caracteres numericos.',
        alphanumeric: (v) => /^[a-zA-Z0-9-]*$/.test(v) || 'El campo solo permite caracteres alfanumericos.',
      },
      documentTypes: [
        { value: null, text: 'Todos' },
        { value: '01', text: 'Factura' },
        { value: '02', text: 'Nota de Crédito' },
        { value: '03', text: 'Nota de Débito' },
        { value: '04', text: 'Guías de Despacho' },
        { value: '05', text: 'Comprobante de Retención de IVA' },
        { value: '06', text: 'Certificación de Débito Fiscal Exonerado' },
      ],
      endMenu: false,
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: 'Crear Numeraciones',
      apiURL: '/api/enterprises',
      method: 'POST',
    }),
    computed: {
      ref() { return this.form.id; },
    },
     async created() {
        const enterprise = this.enterpriseId;
       window.axios.get(`${this.apiURL}/${this.enterpriseId}/series/getPrefix/${enterprise}`)
        .then((response) => {
          if (response.data.code === 500) {
            this.form.prefix = '00';
          } else {
            this.form.prefix = response.data;
          }
        });
      },
    async mounted() {
        this.URL = `${this.apiURL}/${this.enterpriseId}/series/store`;
        if (this.serieId) {
            window.axios.get(`${this.apiURL}/${this.enterpriseId}/series/${this.serieId}`)
            .then((result) => {
              Object.assign(this.form, result.data);
              this.URL = `${this.apiURL}/${this.enterpriseId}/series/${this.serieId}/update`;
              this.method = 'PUT';
              this.title = 'Editar Numeraciones';
              this.message = `Se ha editado la numeración ${result.data.serie} exitosamente.`;
            });
        }
    },
    methods: {
        numerationToValue() {
          if (parseInt(this.form.max_value, 10) <= parseInt(this.form.min_value, 10)) {
            this.$store.dispatch('notifications/show', {
                  message: 'El campo Hasta no puede ser menor al campo Desde',
                  type: 'error',
              });
              this.form.max_value = '';
              this.form.min_value = '';
          } else {
            const url = `/api/enterprises/${this.enterpriseId}/series/getSerie/${this.form.prefix}`;
            window.axios.get(url)
              .then((response) => {
                const maxValue = response.data;
                let prefix = parseInt(this.form.prefix, 10);
                const formMaxValue = parseInt(this.form.max_value, 10);

                if (prefix <= 9) {
                      prefix += 1;
                      if (prefix === 10) {
                        prefix = prefix.toString();
                      } else {
                        prefix = 0 + prefix.toString();
                      }
                  } else {
                      prefix += 1;
                      prefix = prefix.toString();
                  }

                if (maxValue === 99999999) {
                  if (formMaxValue >= 99999999) {
                    this.form.prefix = prefix;
                    this.form.min_value = 1;
                    this.form.max_value = formMaxValue - this.form.min_value;
                  }
                } else if (maxValue < 99999999) {
                  if (formMaxValue > 99999999) {
                    this.form.prefix = prefix;
                    this.form.min_value = 1;
                    this.form.max_value = formMaxValue - this.form.min_value;
                  }
                }
              });
          }
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.snackbar = true;
                this.form.busy = true;
                this.store();
            }
        },
        store() {
            window.axios({
                method: this.method,
                url: this.URL,
                data: this.form,
            })
            .then((response) => {
                if (response.data.codigo === 0) {
                    this.$router.go(-1);
                }
                this.$store.dispatch('notifications/show', {
                    message: response.data.message,
                    type: response.data.type,
                });
                this.form.busy = false;
            }).catch(() => {
                this.form.busy = false;
            });
        },
        save() {
            this.validate(); // someValue
        },
        cancel() {
            this.$router.go(-1); // someValue
        },
        onKeyUpMinimum() {
            const minValue = parseInt(this.form.min_value, 10);
            if (!Number.isNaN(minValue)) {
                this.form.correlative = minValue;
            }
        },
        checkCorrelative() {
            const correlative = parseInt(this.form.correlative, 10);
            if (correlative > parseInt(this.form.max_value, 10) || correlative < parseInt(this.form.min_value, 10)) {
                this.$store.dispatch('notifications/show', {
                    message: 'El correlativo debe estar entre el rango mínimo y máximo',
                    type: 'error',
                });
                this.form.correlative = '';
            }
        },
    },
};
</script>

<style>

</style>
